import { createElement } from 'react';
DivContainer.defaultProps = {
    wrapStyle: {
        height: '120px'
    }
};
function DivContainer(props) {
    const { wrapStyle, } = props;
    return (createElement("div", { className: "div-container", style: wrapStyle }, props.children ? props.children : '普通容器'));
}
export default DivContainer;
export { DivProps } from './PropsType';
